<template>
  <div class="bi-spreadsheet">
    <div class="bi-spreadsheet-delete">
      <i class="far fa-trash-alt cursor-pointer so-remove" v-on:click="removeSpreadsheet()"></i>
    </div>

    <spreadsheet v-on:change="updateState" ref="spreadsheet" :sheetsbar="false" :toolbar="{home: ['bold', 'italic', 'underline', 'backgroundColor', 'alignment', 'merge'], insert:false, data: false}" >
      <spreadsheet-sheet :name="sheetName" />
    </spreadsheet>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';
  import { Spreadsheet, SpreadsheetSheet } from '@progress/kendo-spreadsheet-vue-wrapper';
  import { ConfirmModal } from '@/helpers/confirm-modal';

  @Component({
    components: {
      Spreadsheet,
      SpreadsheetSheet,
    },
  })
  export default class BoardItemSpreadsheet extends Vue {
    @Prop() json;
    @Prop() sheetName;

    async mounted() {
      this.initSpreadSheetData();
    }

    updateState() {
      this.getSpreadSheetJson().then((json) => {
        this.$emit('modelUpdate', JSON.stringify(json));
      });
    }

    removeSpreadsheet() {
      const success = async () => {
        this.$emit('spreadsheetDelete');
      };

      ConfirmModal.confirm(
        this,
        `Are you sure you want to delete this spreadsheet? This action cannot be undone and all data will be permanently lost.`,
        'Confirm',
        'Yes, delete Spreadsheet',
        'No',
        success,
        null,
          'danger'
      );
    }

    getSpreadSheetJson() {
      const spreadsheet: any = this.$refs.spreadsheet;
      const widget = spreadsheet.kendoWidget();

      return widget.saveJSON();
    }

    initSpreadSheetData() {
      const spreadsheet: any = this.$refs.spreadsheet;
      const widget = spreadsheet.kendoWidget();

      widget.renameSheet(widget.activeSheet(), this.sheetName);

      const jsonObj: any = JSON.parse(this.json);

      if (jsonObj && jsonObj.sheets && jsonObj.sheets.length) {
        widget.activeSheet().fromJSON(jsonObj.sheets[0]);
      }
    }
  }
</script>

<style lang="scss">

.k-spreadsheet {
  .k-spreadsheet-quick-access-toolbar, .k-tabstrip-items-wrapper.k-hstack, .k-spreadsheet-action-bar {
    display: none;
  }

  .k-spreadsheet-tabstrip {
    padding-top: 0;
  }
}

.k-spreadsheet .k-tabstrip-wrapper .k-tabstrip-items {
  padding-left: .3em !important;
}
</style>

<style scoped lang="scss">


  .bi-spreadsheet {
    position: relative;

    .bi-spreadsheet-delete {
      position: absolute;
      top: 8px;
      right: 8px;
      z-index: 1000;
      font-size: 14px;
      color: red;
    }

    .btn-group {
      button {
        flex: 1 1 0;
      }
    }

    .k-spreadsheet {
      width: auto !important;
    }
  }
</style>
